<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" class="scaling-svg">
      <g id="Icon_blank_empty">
        <g id="Icon_blank_empty-2" data-name="Icon_blank_empty" transform="translate(1.714 0.857)">
          <path
            id="Shape"
            d="M6.75,10.286H.964A1,1,0,0,1,0,9.257V1.028A1,1,0,0,1,.964,0H5.785L7.714,2.057v7.2A1,1,0,0,1,6.75,10.286Zm-5.3-9.257a.5.5,0,0,0-.482.514v7.2a.5.5,0,0,0,.482.514H6.268a.5.5,0,0,0,.483-.514V3.086H4.821V1.028Zm4.339,0V2.057H6.75Z"
          />
        </g>
      </g>
      <g id="_10_Dollar" data-name="10 Dollar" transform="translate(4.094 3.702)">
        <path
          id="Fill_149"
          data-name="Fill 149"
          d="M2.682,3.046a1.037,1.037,0,0,0-.742-.968L.963,1.785a.276.276,0,0,1-.2-.291.285.285,0,0,1,.287-.249h.574a.67.67,0,0,1,.388.124.291.291,0,0,0,.376-.026l.136-.136A.288.288,0,0,0,2.5.777,1.439,1.439,0,0,0,1.724.483v-.2A.287.287,0,0,0,1.437,0H1.245A.287.287,0,0,0,.958.287v.2A1.064,1.064,0,0,0,0,1.55a1.037,1.037,0,0,0,.742.968l.977.293a.276.276,0,0,1,.172.376.287.287,0,0,1-.265.164H1.054a.67.67,0,0,1-.388-.124.291.291,0,0,0-.376.026L.154,3.39a.287.287,0,0,0,.026.43,1.423,1.423,0,0,0,.779.294v.2a.287.287,0,0,0,.287.287h.192a.287.287,0,0,0,.287-.287v-.2a1.066,1.066,0,0,0,.958-1.065"
          transform="translate(0 0)"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CostDocumentsIcon extends Vue {}
</script>

<style>
</style>
